import React from "react";
import { useTranslation } from "react-i18next";
import HotspotIndicatorSelect from "../components/HotspotIndicatorSelect";
import HotspotTotal from "../components/HotspotTotal";
import HotspotChart from "../components/HotspotChart";

/** Hotspot analysis card — the top 10 EPDs contributing most to the selected GWP indicator. */
export default function HotspotCard() {
  const { t } = useTranslation();

  return (
    <div className="border mb-6 border-gray-300 bg-white rounded-lg overflow-hidden p-6">
      <div className="flex justify-between items-start gap-4 mb-4">
        <div>
          <h3 className="text-lg font-bold">{t("levels.hotspotTitle")}</h3>
          <p className="text-xs text-gray-400 max-w-3xl mt-1">
            {t("levels.hotspotRule")}
          </p>
        </div>
        <HotspotIndicatorSelect />
      </div>
      <HotspotTotal />
      <HotspotChart />
    </div>
  );
}
